export default __webpack_public_path__ + "static/media/empty-slider-dot.0020da55.svg";